import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./ForgotPassword.css";
import { Strings } from "../../Default/Strings";
import { useForgotPassword } from "../../hooks/useForgotPassword";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState<string>("");
  const { sendRecoveryEmail, success, loading, error } = useForgotPassword();
  const navigate = useNavigate();

  const handleForgotPassword = (e: React.FormEvent) => {
    e.preventDefault();
    sendRecoveryEmail(email);
  };

  if (success) {
    return (
      <div className="forgot-password-container">
        <img
          src="/turminha_logo.png"
          alt="Turminha Educa Logo"
          className="forgot-password-logo"
        />
        <div className="success-message">
          <h1 className="success-title">
            {Strings.FORGOT_PASSWORD.SUCCESS_TITLE}
          </h1>
          <p className="success-text">
            {Strings.FORGOT_PASSWORD.SUCCESS_MESSAGE}
          </p>
          <button
            className="forgot-password-button"
            onClick={() => navigate("/login")}
          >
            {Strings.FORGOT_PASSWORD.BACK_TO_LOGIN}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="forgot-password-container">
      <img
        src="/turminha_logo.png"
        alt="Turminha Educa Logo"
        className="forgot-password-logo"
      />
      <h1 className="forgot-password-title">{Strings.FORGOT_PASSWORD.TITLE}</h1>
      <p className="forgot-password-subtitle">
        {Strings.FORGOT_PASSWORD.SUBTITLE}
      </p>

      <form
        className="forgot-password-form-vertical"
        onSubmit={handleForgotPassword}
      >
        <input
          type="email"
          placeholder={Strings.FORGOT_PASSWORD.EMAIL_PLACEHOLDER}
          className="forgot-password-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />

        {error && <p className="forgot-password-error-message">{error}</p>}

        <button
          className="forgot-password-button"
          type="submit"
          disabled={loading}
        >
          {loading
            ? Strings.FORGOT_PASSWORD.SENDING
            : Strings.FORGOT_PASSWORD.SEND_BUTTON}
        </button>

        <button
          className="forgot-password-button-secondary"
          type="button"
          onClick={() => navigate("/login")}
        >
          {Strings.FORGOT_PASSWORD.BACK_TO_LOGIN}
        </button>
      </form>
    </div>
  );
};

export default ForgotPassword;
